/* eslint-disable no-empty-pattern */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import courseServices from 'services/courseServices';
import { toastSuccessIfMessage } from 'utils/toastFromResponse';

export interface CourseState {
  myGeneralInfo: any;
  myGradeAndCourse: any;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: CourseState = {
  myGeneralInfo: null,
  myGradeAndCourse: null,
  status: 'idle',
};
export const getGeneral: any = createAsyncThunk('course/getGeneral', async (studentId: any, {rejectWithValue}) => {
  try {
    const response = await courseServices.getGeneral(studentId);
    return response;
  }
  catch (err) {
    const error = err as AxiosError; 
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});
export const updateGeneral: any = createAsyncThunk(
  'course/updateGeneral',
  async (payload: any, { getState, rejectWithValue }) => {
    // const state: any = getState();
    // const myGeneralInfo = state.course.myGeneralInfo;
    try {
      let myGeneralInfo = await courseServices.getGeneral(payload.student_id);
      if (myGeneralInfo) {
        const response = await courseServices.updateGeneral(payload);
        toastSuccessIfMessage(response);
        return response;
      } else {
        const response = await courseServices.createGeneral(payload);
        toastSuccessIfMessage(response);
        return response;
      }
    }
    catch (err) {
      const error = err as AxiosError; 
      if (!error.response) {
        throw err;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
export const getGradeAndCourse: any = createAsyncThunk(
  'course/getGradeAndCourse',
  async (studentId: any, {rejectWithValue}) => {
    try {
      const response = await courseServices.getGradeAndCourse(studentId);
      return response;
    }
    catch (err) {
      const error = err as AxiosError; 
      if (!error.response) {
        throw err;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateGradeAndCourse: any = createAsyncThunk(
  'course/updateGradeAndCourse',
  async (payload: any, { getState, rejectWithValue }) => {
    // const state: any = getState();
    // const myGradeAndCourse = state.course.myGradeAndCourse;
    try {
      let myGradeAndCourse = await courseServices.getGradeAndCourse(payload.student_id);

      const { silent, ...apiPayload } = payload;

      if (myGradeAndCourse) {
        const response = await courseServices.updateGradeAndCourse({
          ...myGradeAndCourse,
          ...apiPayload,
        });
        const result = {
          ...response,
          silent: silent || false
        };
        if (!result.silent) {
          toastSuccessIfMessage(result);
        }
        return result;
      } else {
        const response = await courseServices.createGradeAndCourse(payload);
        const result = {
          ...response,
          silent: silent || false
        };
        if (!result.silent) {
          toastSuccessIfMessage(result);
        }
        return result;
      }
    }
    catch (err) {
      const error = err as AxiosError; 
      if (!error.response) {
        throw err;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
export const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {},
  extraReducers: {
    [getGeneral.pending]: (state) => {
      state.status = 'loading';
    },
    [getGeneral.rejected]: (state) => {
      state.status = 'failed';
    },
    [getGeneral.fulfilled]: (state, action) => {
      state.myGeneralInfo = action.payload;
      state.status = 'idle';
    },
    //
    [updateGeneral.pending]: (state) => {
      state.status = 'loading';
    },
    [updateGeneral.rejected]: (state) => {
      state.status = 'failed';
    },
    [updateGeneral.fulfilled]: (state, action) => {
      state.myGeneralInfo = action.payload;
      state.status = 'idle';
    },
    [getGradeAndCourse.pending]: (state) => {
      state.status = 'loading';
    },
    [getGradeAndCourse.rejected]: (state) => {
      state.status = 'failed';
    },
    [getGradeAndCourse.fulfilled]: (state, action) => {
      state.myGradeAndCourse = action.payload;
      state.status = 'idle';
    },
    //
    [updateGradeAndCourse.pending]: (state) => {
      state.status = 'loading';
    },
    [updateGradeAndCourse.rejected]: (state) => {
      state.status = 'failed';
    },
    [updateGradeAndCourse.fulfilled]: (state, action) => {
      // PUT returns { statusCode, message }, not the course row. Replacing the
      // store with that payload drops every grade array until the next fetch.
      const payload = action.payload;
      const keepsCourses =
        payload &&
        (Object.prototype.hasOwnProperty.call(payload, 'grade_9_course_array') ||
          Object.prototype.hasOwnProperty.call(payload, 'grade_10_course_array') ||
          Object.prototype.hasOwnProperty.call(payload, 'grade_11_course_array') ||
          Object.prototype.hasOwnProperty.call(payload, 'grade_12_course_array'));
      if (keepsCourses) {
        state.myGradeAndCourse = payload;
      }
      state.status = 'idle';
    },
    //
  },
});

export const {} = courseSlice.actions;
